// extracted by css-extract-rspack-plugin
export default {"CheckIcon":"PlansRadioGroup-module__CheckIcon__XZ51p"};